import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-20 sm:px-8" data-id="element-211" data-mp="3ksqgb9iahk82">
      <div className="mx-auto w-full max-w-5xl" data-id="element-212" data-mp="3fy2zlwtj1u41">
        <div className="mx-auto max-w-2xl text-center" data-id="element-213" data-mp="3b0uf3pkwpdzm">
          <Reveal data-id="element-214" data-mp="3b01el6cjjkpx">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-level-blue" data-id="element-215" data-mp="3ayqdxfee6t31">
              För lärare och tränare
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-216" data-mp="31ybelc4lfdgj">
            <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-217" data-mp="3228yw12wqb20">
              Ett enklare sätt att känna sig förberedd inför varje pass
            </h2>
          </Reveal>

          <Reveal delay={0.12} data-id="element-218" data-mp="v96la316w1l1">
            <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-219" data-mp="v8dmbo8h2gdg">
              Innebandy Ready är byggt kring de problem som idrottslärare och tränare
              möter varje vecka: tidsbrist, planering och behovet av tydlig progression.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-220" data-mp="m62p64pm27tu">
          {testimonials.map((testimonial, index) => <Reveal key={testimonial.quote} delay={index % 3 * 0.06} data-id="element-221" data-mp="79lfrj0zf39x" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-sand bg-white p-6" data-id="element-222" data-mp="c7wo1pbmp5q1">
                <QuoteIcon className="h-5 w-5 text-sand" aria-hidden="true" data-id="element-223" data-mp="zxhc2mmn2t66" />
                <blockquote className="mt-4 text-[15px] leading-relaxed text-navy" data-id="element-224" data-mp="14w296d6lgwqe">
                  {testimonial.quote}
                </blockquote>
                <figcaption className="mt-auto pt-6 text-xs font-semibold uppercase tracking-[0.1em] text-muted" data-id="element-225" data-mp="q6cx3mwyr8bc">
                  — {testimonial.attribution}
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}